import {
  REQUEST,
  REQUEST_SUCCESS,
  REQUEST_FAIL,
  REQUEST_COMPLETE
} from "./constants";
import API from "redux/api/sites";

export const loadStart = () => ({ type: REQUEST });

export const receiveList = json => ({
  type: REQUEST_SUCCESS,
  payload: json.list,
  receivedAt: Date.now()
});

export const receiveFail = ({ errors, status }) => ({
  type: REQUEST_FAIL,
  errors,
  status
});

export function loadAll() {
  return dispatch => {
    dispatch(loadStart());
    let status;
    return API.get()
      .then(response => {
        status = response.status;
        return response.json().then(json => ({
          ok: response.ok,
          status: response.status,
          json
        }));
      })
      .then(({ json, ok }) => {
        ok
          ? dispatch(receiveList(json))
          : dispatch(receiveFail({ errors: "Что-то пошло не так", status }));
        return dispatch({ type: REQUEST_COMPLETE });
      })
      .catch(errors => dispatch(receiveFail({ errors, status })));
  };
}
